import { gql } from "@apollo/client";

export const GET_EMAIL_TEMPLATES = gql`
  query EmailTemplates(
    $where: EmailTemplateWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    emailTemplates(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        label
        description
        icon
        subject
        body
        active
        createdDate
        updatedDate
      }
      count
    }
  }
`;

export const GET_EMAIL_TEMPLATE = gql`
  query EmailTemplate($where: EmailTemplateWhereInput) {
    emailTemplate(where: $where) {
      id
      label
      description
      icon
      subject
      body
      active
      createdDate
      updatedDate
    }
  }
`;
